import { useDispatch, useSelector } from 'react-redux';

import { useLever } from 'Lib/ConfigService';
import { LEVER_WEB_DISCOUNT_BANNER_ENABLED } from 'Lib/ConfigService/levers';
import { ONE_DAY } from 'Lib/constants/time';

import { getIsRemote } from 'Store/context/selectors';
import { setUpsellShown } from 'Store/purchase/actions';
import {
  getShouldShowWebDiscountBanner,
  getWebDiscountBannerAmountShown,
  getWebDiscountBannerTimestamp,
} from 'Store/purchase/selectors';
import { getCurrentPath } from 'Store/routing/selectors';

const MAX_AMOUNT_SHOW_BANNER = 3;
const ROUTE_PREFIX_TO_HIDE = [
  'appeals-center',
  'banned',
  'checkout',
  'gift',
  'onboarding',
  'select',
  'subscription',
  'underReview',
  'verify',
];

const useShouldShowBanner = () => {
  const dispatch = useDispatch();
  const isBannerEnabled = useLever(LEVER_WEB_DISCOUNT_BANNER_ENABLED);
  const shouldShowWebDiscountBanner = useSelector(getShouldShowWebDiscountBanner);
  const isRemote = useSelector(getIsRemote);
  // Is lever enabled, and banner has not been shown/a purchase has not been made, and is not remote view
  const canShowBanner = isBannerEnabled && shouldShowWebDiscountBanner && !isRemote;
  const amountShown = useSelector(getWebDiscountBannerAmountShown);
  const lastShownTimestamp = useSelector(getWebDiscountBannerTimestamp);
  const currentPath = useSelector(getCurrentPath);
  // Don't show banner for select flow and on checkout page
  const hideForPath = !!ROUTE_PREFIX_TO_HIDE.filter((route) =>
    currentPath?.toLowerCase().includes(route.toLowerCase())
  ).length;

  if (canShowBanner && !hideForPath) {
    // Rate limit banner to once a day and only 3 times max
    const isWithinTimeLimit = Date.now() - lastShownTimestamp >= ONE_DAY;
    const isShownLessThanMaxAmount = amountShown < MAX_AMOUNT_SHOW_BANNER;
    if (!isShownLessThanMaxAmount) {
      dispatch(
        setUpsellShown({
          upsellType: 'webDiscountBanner',
          stopShowingUpsell: true,
        })
      );
    }
    return isWithinTimeLimit && isShownLessThanMaxAmount;
  }
  return false;
};

export default useShouldShowBanner;
